import { render, staticRenderFns } from "./student-card-1.vue?vue&type=template&id=e70cb25c&scoped=true"
import script from "./student-card-1.vue?vue&type=script&lang=js"
export * from "./student-card-1.vue?vue&type=script&lang=js"
import style0 from "./student-card-1.vue?vue&type=style&index=0&id=e70cb25c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70cb25c",
  null
  
)

export default component.exports